import React from 'react'

import * as S from './styles'

function Tooltip({ title, description, width }) {
  return (
    <S.TooltipContent width={width}>
      <S.TooltipTitle>
        <span>{title}</span>
        <button>x</button>
      </S.TooltipTitle>
      <S.TooltipDescription>{description}</S.TooltipDescription>
  </S.TooltipContent>
  )
}

export default Tooltip